// Mock data for Vaikuntha Media website

export const services = [
  {
    id: 1,
    title: "Media",
    description: "Strategic media planning, buying, and representation across traditional and digital platforms. Leveraging data-driven insights to maximize reach and impact.",
    icon: "Tv"
  },
  {
    id: 2,
    title: "Marketing",
    description: "Comprehensive marketing strategies that drive measurable business outcomes. From campaign design to execution and optimization.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Communication",
    description: "Clear, responsible, brand-centric narratives that create meaningful audience experiences. Bridging communication gaps with precision.",
    icon: "MessageSquare"
  },
  {
    id: 4,
    title: "Content",
    description: "Compelling content creation across formats - from storytelling to technical documentation. Content that cuts through digital noise.",
    icon: "FileText"
  },
  {
    id: 5,
    title: "Branding",
    description: "Building distinct brand identities that earn attention and command respect. Strategic positioning that resonates with target audiences.",
    icon: "Sparkles"
  },
  {
    id: 6,
    title: "PR (Public Relations)",
    description: "Reputation management and strategic communications. Building and maintaining positive relationships with stakeholders and media.",
    icon: "Users"
  },
  {
    id: 7,
    title: "Digital",
    description: "End-to-end digital solutions from website development to mobile apps. Scalable platforms built for growth and user engagement.",
    icon: "Globe"
  },
  {
    id: 8,
    title: "AI Consulting",
    description: "Responsible AI integration for communication and marketing. Future-ready solutions that combine automation with human relevance.",
    icon: "Brain"
  },
  {
    id: 9,
    title: "LinkedIn Sales Navigation",
    description: "Strategic B2B lead generation and relationship building on LinkedIn. Data-driven approach to professional networking.",
    icon: "Linkedin"
  },
  {
    id: 10,
    title: "Media Representation",
    description: "International media representation services connecting brands with global markets. Your bridge to worldwide media opportunities.",
    icon: "Radio"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Bomsi",
    role: "Director",
    focus: "Media Sales • Strategic Partnerships • National & International Networks",
    bio: "Seasoned media and communications leader with extensive experience in sales, marketing, and business leadership. Global exposure through collaboration with international media platforms (WSJ, Newsweek, Gulf News, SPH). Known for building impactful brand partnerships and aligning communication strategies with measurable business outcomes.",
    email: "bomsi@vaikunthamedia.com",
    phone: "+919820172027",
    image: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/r7ns76mn_bomsi.png"
  },
  {
    id: 2,
    name: "Rishikesh",
    role: "Digital, Content & Communication Lead",
    focus: "Where Story, Strategy, and Responsibility Converge",
    bio: "Communication expert with a multidisciplinary background spanning journalism, digital communication, broadcasting, brand strategy, and content design. Decades of cross-industry exposure, blending creative storytelling, media intelligence, and strategic clarity. Bridges traditional media, digital ecosystems, and emerging AI-driven communication frameworks.",
    email: "rishi@vaikunthamedia.com",
    phone: "+919611331976",
    image: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/hpnzmpef_rishi.jpg"
  },
  {
    id: 3,
    name: "Dr. Rachana Chowdhary",
    role: "Board Member – Vaikuntha Media",
    focus: "Founder | Architect of India's Largest Media Capability Centre (MCC)",
    bio: "Dr. Rachana Chowdhary stands at the intersection of media, consciousness, and national transformation. A strategist, institution-builder, and narrative architect, she is leading the creation of India's largest Media Capability Centre (MCC)—a new-age platform designed not merely to amplify voices, but to shape influence with integrity. On the Board of Vaikuntha Media, Dr. Chowdhary contributes to a shared mission: to build ecosystems that elevate discourse and align communication with higher purpose, integrating media precision with moral clarity, human relevance with cultural depth, and responsible AI with societal accountability.",
    email: "connect@vaikunthamedia.com",
    phone: "+918779638170",
    image: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/iagf799n_drranchana.png"
  },
  {
    id: 4,
    name: "Govind Dhiman",
    role: "Digital Art Director & Design Partner",
    focus: "Driving Digital Growth with Scalable Design Strategy",
    bio: "Practical, results-oriented mindset in digital design strategy and execution. Experience with large-scale content platforms and audience growth initiatives. Successfully launched and scaled multiple digital media properties, including owning/operating over 400 Google News-verified websites.",
    email: "connect@vaikunthamedia.com",
    phone: "+918779638170",
    image: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/9jzgs6mw_govind.png"
  },
  {
    id: 5,
    name: "Samir Khanal",
    role: "Tech & Production Lead",
    focus: "Turning Complex Technology into Scalable Digital Solutions",
    bio: "Over 15 years of experience in technology development and digital production. Expertise in content-managed websites, web applications, mobile app ecosystems, API architecture, and scalable backend systems. Expanding into AI-driven solutions and intelligent agent development, integrating automation and adaptive technologies.",
    email: "connect@vaikunthamedia.com",
    phone: "+918779638170",
    image: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/ls9cryl0_samir.png"
  }
];

export const partners = [
  { name: "Syngene", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/chmy5ubl_image.png" },
  { name: "Zensa", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/uklzkbzh_image.png" },
  { name: "Air India", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/g8pyesq4_image.png" },
  { name: "KFH", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/xqxkxxpi_image.png" },
  { name: "Ramsay Health Care", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/fujdcgoy_image.png" },
  { name: "Alrajhi Bank", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/8akdccmh_image.png" },
  { name: "Institut Jantung Negara", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/fu06y5bx_image.png" },
  { name: "Invest Telangana", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/7zlq0w62_image.png" },
  { name: "Uttar Pradesh Tourism", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/aldznlfg_image.png" },
  { name: "Maharashtra Tourism", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/dvbz5qv3_image.png" },
  { name: "Everlife Chemopharm", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/qrfnpb2n_image.png" },
  { name: "Survival Technologies", logo: "https://customer-assets.emergentagent.com/job_content-nexus-97/artifacts/gskbezku_image.png" }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Responsible AI in Marketing Communication",
    excerpt: "Exploring how AI can enhance marketing strategies while maintaining ethical practices and human relevance in brand communication.",
    date: "2026-01-15",
    category: "AI & Technology",
    author: "Rishikesh",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800"
  },
  {
    id: 2,
    title: "Bridging the Communication Gap in Digital Transformation",
    excerpt: "How modern businesses can transform fragmented messaging into clear, brand-centric narratives that resonate with audiences.",
    date: "2026-01-10",
    category: "Communication Strategy",
    author: "Bomsi",
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800"
  },
  {
    id: 3,
    title: "Building Ecosystems: Media Precision Meets Cultural Intelligence",
    excerpt: "Our approach to creating integrated communication ecosystems that combine data-driven media planning with cultural insights.",
    date: "2026-01-05",
    category: "Strategy",
    author: "Vaikuntha Team",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800"
  },
  {
    id: 4,
    title: "Scaling Digital Design: Lessons from 400+ News Websites",
    excerpt: "Key insights from managing large-scale digital content platforms and driving audience growth through strategic design.",
    date: "2025-12-28",
    category: "Digital Design",
    author: "Govind Dhiman",
    image: "https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=800"
  },
  {
    id: 5,
    title: "LinkedIn Sales Navigation: B2B Lead Generation in 2026",
    excerpt: "Data-driven strategies for professional networking and B2B relationship building on LinkedIn's evolving platform.",
    date: "2025-12-20",
    category: "Sales & Marketing",
    author: "Bomsi",
    image: "https://images.unsplash.com/photo-1611944212129-29977ae1398c?w=800"
  },
  {
    id: 6,
    title: "API-First Architecture for Modern Content Management",
    excerpt: "Building scalable, flexible content systems with API-first approaches and microservices architecture.",
    date: "2025-12-15",
    category: "Technology",
    author: "Samir Khanal",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800"
  }
];

export const processSteps = [
  {
    number: "01",
    title: "Discover",
    subtitle: "Understand & Engage",
    description: "We immerse ourselves in your business, understanding your challenges, goals, and target audiences to build a foundation for success."
  },
  {
    number: "02",
    title: "Correlate & Contextualize",
    subtitle: "Analyze & Assess",
    description: "Deep analysis of market dynamics, competitive landscape, and audience behaviors to inform strategic decision-making."
  },
  {
    number: "03",
    title: "Define Objectives",
    subtitle: "Set Goals & Direction",
    description: "Clear, measurable objectives aligned with your business outcomes, setting the direction for all tactical execution."
  },
  {
    number: "04",
    title: "Create & Deliver",
    subtitle: "Execute & Approve",
    description: "Bringing strategies to life with creative excellence, technical precision, and rigorous quality control."
  },
  {
    number: "05",
    title: "Track & Optimize",
    subtitle: "Measure & Improve",
    description: "Continuous monitoring, analysis, and optimization to ensure sustained performance and improved outcomes."
  }
];

export const industries = [
  {
    title: "Government & Public Sector",
    description: "Strategic communication and digital transformation for government agencies and public institutions."
  },
  {
    title: "Consumer Markets",
    description: "B2C, D2C, and hybrid commerce solutions for brands targeting consumer audiences."
  },
  {
    title: "Knowledge-Intensive Industries",
    description: "Specialized communication for healthcare, education, technology, and professional services sectors."
  }
];

export const companyInfo = {
  name: "Vaikuntha Media",
  tagline: "Building Meaning. Amplifying Impact. Delivering Solutions.",
  founded: "2018",
  description: "Vaikuntha Media is a multidisciplinary agency founded in 2018 by a collective of like-minded industry experts from India and abroad. We specialize in transforming fragmented messaging into clear, responsible, and brand-centric narratives that create meaningful audience experiences.",
  vision: "To build ecosystems that combine Media Precision + Human Relevance + Cultural Intelligence + Ethical Practice + Digital Strength + Responsible AI.",
  email: "connect@vaikunthamedia.com",
  phone: "+918779638170",
  website: "www.vaikunthamedia.com"
};
